import type { Route } from '@angular/router';
import { CanDeactivateGuard } from '@clean-code/shared/components/ui-can-deactivate';
import { TimeSeriesAnalysisPreviewComponent } from './components/time-series-analysis-preview/time-series-analysis-preview.component';
import { TimeSeriesAnalysisIdentifierListComponent } from './time-series-analysis-identifier-list.component';

export const timeSeriesAnalysisIdentifierRoute: Route = {
  path: 'time-series-analysis-identifier',
  component: TimeSeriesAnalysisIdentifierListComponent,
  children: [
    {
      path: 'preview/:id',
      loadComponent: () =>
        import(
          './components/form/time-series-analysis-identifier-form.component'
        ).then((mod) => mod.FeatureTimeSeriesAnalysisIdentifierFormComponent),
      canDeactivate: [CanDeactivateGuard],
    },
    // {
    //   path: 'parser-preview/:id',
    //   component: TimeSeriesAnalysisPreviewComponent,
    // },
  ],
};
